import React, { useState, useEffect } from "react";
import styles from "./CountPill.module.scss";

export const CountPill = (props) => {
  const { count } = props;

  return <span className={styles.pill}>{count}</span>;
};
